import $ from "jquery"

export class EnvironmentHelper {

    static isAnimationEnabled(): boolean {
        let value = $("meta[name=CUPU_NO_ANIMATION]").attr("content")
        return value !== "1"
    }
}
